import type { DatesRange } from "app/components/campaigns/shared/types";
import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

const MIN_WEEKLY_IN_DAYS = 15; // Allow Weekly when the date range is more than 2 weeks
const MIN_MONTHLY_IN_MONTHS = 2; //  Allow Monthly when the date range is 2 months or more

/**
 * Returns the minimum number of days based on the given granularity and date range
 * @param granularity
 * @param durationObject
 */
export const getMinGranularityDays = (
    granularity: GranularityNames.WEEKLY | GranularityNames.MONTHLY,
    durationObject: DatesRange,
): number => {
    if (granularity === GranularityNames.WEEKLY) {
        return MIN_WEEKLY_IN_DAYS;
    }
    // Calculate days for the next 2 months and return the difference
    return durationObject.from.clone().add(MIN_MONTHLY_IN_MONTHS, "month").diff(durationObject.from, "day");
};
